// extracted by mini-css-extract-plugin
export var chip = "_5i-0";
export var filterDropdown = "_5i-5";
export var filterItem = "_5i-6";
export var icon = "_5i-1";
export var removeButton = "_5i-3";
export var removeIcon = "_5i-4";
export var separator = "_5i-2";